const STORAGE_KEY = "contactPopupPulseDismissed";
const FAQ_HOLDER_CLASS = "Schellevis\\FaqHolder";
const FAQ_HOLDER_TIMER_MS = 20000;
const FOOTER_INTERSECTION_THRESHOLD = 0.15;

export function isPulseDismissed() {
    try {
        return sessionStorage.getItem(STORAGE_KEY) === "1";
    } catch {
        return false;
    }
}

export function setupPulseTriggers({ pageClass, onActivate }) {
    if (isPulseDismissed()) {
        return { cleanup: () => {} };
    }

    let activated = false;
    let footerObserver = null;
    let faqHolderTimer = null;

    const activate = () => {
        if (activated || isPulseDismissed()) {
            return;
        }

        activated = true;
        onActivate();
    };

    const footer = document.querySelector("#footer");

    if (footer && typeof IntersectionObserver !== "undefined") {
        footerObserver = new IntersectionObserver(
            (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                    activate();
                    footerObserver?.disconnect();
                    footerObserver = null;
                }
            },
            { threshold: FOOTER_INTERSECTION_THRESHOLD }
        );
        footerObserver.observe(footer);
    }

    if (pageClass === FAQ_HOLDER_CLASS) {
        faqHolderTimer = window.setTimeout(() => {
            activate();
            faqHolderTimer = null;
        }, FAQ_HOLDER_TIMER_MS);
    }

    const cleanup = () => {
        footerObserver?.disconnect();
        footerObserver = null;

        if (faqHolderTimer !== null) {
            window.clearTimeout(faqHolderTimer);
            faqHolderTimer = null;
        }
    };

    return { cleanup };
}

export function dismissPulseTriggers(cleanup) {
    try {
        sessionStorage.setItem(STORAGE_KEY, "1");
    } catch {
        // Ignore storage errors (private browsing, etc.)
    }

    cleanup?.();
}
